goog.provide("shadow.js.shim.module$src$svg$wpp$charts$ranking_svg$default");
shadow.js.shim.module$src$svg$wpp$charts$ranking_svg$default = shadow.js.shim.module$src$svg$wpp$charts$ranking_svg.default;
